<template>
  <form
    id="customer-form"
    class="panel-body"
    @submit.prevent="saveCustomer(customer)"
  >
    <ul v-if="formErrors">
      <li
        v-for="(group, key) in formErrors"
        :key="key"
        v-text="group[0]"
      />
    </ul>
    <ul class="list-unstyled">
      <li>
        <!-- eslint-disable vue/no-mutating-props -->
        <component
          :is="editing ? `${field.type}-field` : 'span-field'"
          v-for="(field, key) in customer.fields"
          :key="`field${key}`"
          v-model="customer[key]"
          :name="key"
          :validation="field.validation"
          v-bind="field"
          :data-vv-scope="`customer-${customer.id}`"
        />
        <!-- eslint-enable vue/no-mutating-props -->
      </li>
    </ul>
    <input
      v-if="editing"
      type="submit"
      class="btn btn-primary pull-right"
      value="Submit"
    >
  </form>
</template>

<script>
import CustomerModel from '../../../models/customer';
import DateField from '../../partials/field/date.vue';
import SelectField from '../../partials/field/select.vue';
import SpanField from '../../partials/field/span.vue';
import TextField from '../../partials/field/text.vue';
import TelephoneField from '../../partials/field/telephone.vue';

export default {
  components: {
    DateField,
    SelectField,
    SpanField,
    TelephoneField,
    TextField,
  },
  props: {
    customer: {
      type: CustomerModel,
      required: true,
    },
    editing: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formErrors: {},
    };
  },
  methods: {
    saveCustomer(customer) {
      const app = this;
      app.$validator.validate(`customer-${customer.id}.*`)
        .then((valid) => {
          if (valid) {
            customer.save()
              .then(() => {
                this.$emit('updated');
                this.formErrors = {};
              }).catch((errors) => {
                this.formErrors = errors;
              });
          }
        });
    },
  },
};
</script>

<style type="text/scss" lang="scss" scoped="scoped">
    @import 'node_modules/bootstrap-sass/assets/stylesheets/bootstrap/variables';
    @media(min-width: $screen-xs-max) {
        #customer-form {
            ul {
                column-count: 2;
                .form-group {
                    break-inside: avoid-column;
                    -webkit-column-break-inside: avoid;
                }
            }
        }
    }
</style>
